<template>
  <div :class="classes">
    <pt-page-title v-if="!hideTitle" title="生产任务" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="filterForm.searchKey">
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" labelWidth="100px" :displayVertical="true" v-model="filterForm" ref="filter">
      <template slot="labTester">
        <lab-staff-selector v-model="filterForm.labTester"></lab-staff-selector>
      </template>
      <div :class="$style['buttons']">
        <div>
          <el-button type="primary" @click="handleFilter(false)">筛选</el-button>
					<template v-if="hasDownload">
            <el-button v-if="!noDownLoad" type="primary" @click="downloadExcel" :loading="downloadLoading">下载</el-button>
            <el-button type="primary" @click="downloadHistory">下载历史</el-button>
					</template>
          <template v-if="hideTitle">
            <!-- <el-button v-if="!noDownLoad" type="primary" @click="exportExcel" :loading="exportLoading">下载</el-button> -->
          </template>
          <template v-else>
            <template v-if="!noExportOption">
              <el-button type="primary" @click="exportExcel" :loading="exportLoading">导出</el-button>
              <el-button type="primary" @click="exportExcel(true)" :loading="exportLoading">全部导出</el-button>
              <el-button type="primary" @click="exportHistory">导出历史</el-button>
            </template>
						</template>

          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
        </div>
        <div v-if="!hasComplete">
          <el-button type="primary" :class="$style['button__box']" @click="dialogVisible = true">批量操作</el-button>
          <el-button type="primary" :class="$style['button__box']" @click="handleReassign">改派任务</el-button>
          <el-button type="primary" :class="$style['button__box']" :disabled="!HAS_PERM_DELAY" @click="handleDelay">任务延期</el-button>
        </div>
        <div v-if="showSearch" style="display:flex;">
          <el-input style="margin-right:10px;" placeholder="请输入关键字搜索" v-model="filterForm.searchKey">
          </el-input>
          <el-button type="primary" @click="search">搜索</el-button>
        </div>
      </div>
    </pt-page-factor-filter>
    <!-- table -->
    <pt-prodution-task-table 
      ref="table" 
      :tableLabels="tableLabels" 
      :selectType="selectType" 
      :selectedKeys="selectedKeys" 
      @selection-change="updateSelectedData" 
      :params="params" 
      :billId="billId" 
      :onlyNoBill="onlyNoBill" 
      :status="status"
      :isReceiveExamData="isReceiveExamData"
      :isOrderBack="isOrderBack"
      @getAllSize="getAllSize"
    >
      <template slot-scope="scope">
        <el-button type="text" @click.stop="goDetail(scope.row.id)">详情
        </el-button>
				<el-button v-if="hasDownload" type="text" @click.stop="goDownload(scope.row.id)">下载
        </el-button>
        <!-- <el-button
          type="text"
          @click.stop="goEdit(scope.row.orderId, scope.row)"
          v-if="HAS_PERM_LAB_EDIT_ORDER && scope.row.orderStatusEnum !== 'CLOSED'"
          >编辑
        </el-button> -->
      </template>
    </pt-prodution-task-table>

    <!--  -->
    <task-delay-dialog v-if="!hasComplete" :dialogVisible="showDelay" :taskDatas="selectData" @reload="reload" @close="showDelay = false"></task-delay-dialog>
    <!--  -->
    <task-reassign-dialog v-if="!hasComplete" :dialogVisible="showReassign" :taskDatas="selectData" @reload="reload" @close="showReassign = false"></task-reassign-dialog>

    <!-- 批量操作选择的dialog -->
    <pt-lot-operate-choice-dialog isTask :dialogVisible="dialogVisible" :handle-close="()=>dialogVisible = false"></pt-lot-operate-choice-dialog>
  </div>
</template>

<script>
import fillUrl from '@/mixins/fillUrl'
import ptProdutionTaskTable from './pt-production-task-table/withData.vue'
import ptPageTitle from 'cps/base/pt-page-title'
import labStaffSelector from 'cps/selector/lab-staff-selector.vue'
import taskDelayDialog from 'cps/common/task-delay-dialog.vue'
import taskReassignDialog from 'cps/common/task-reassign-dialog.vue'
import { filterLabels, tableLabels } from './options'
import { emptyObject } from '@/utils/lifebankUtils'
import ptLotOperateChoiceDialog from 'cps/trust-deed/pt-lot-operate-choice-dialog'
import { hasPermissions } from 'utils/permissions'
// 组件class前缀
const prefixCls = 'pt-production-task-list'

export default {
  name: 'pt-production-task-list',
  mixins: [fillUrl],
  components: {
    ptPageTitle,
    ptProdutionTaskTable,
    labStaffSelector,
    taskDelayDialog,
    taskReassignDialog,
    ptLotOperateChoiceDialog
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    HAS_PERM_DELAY () {
      const M_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_T_M')
      const SETTLEMENT_PERM = this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_T_08')
      return M_PERM || SETTLEMENT_PERM
    },
  },
  props: {
		hasDownload: Boolean,
    hideTitle: {
      type: Boolean,
      default: false
    },
    hasComplete: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    selectType: {
      type: String,
      default: 'checkbox'
    },
    selectedKeys: {
      type: [String, Array],
      default: ''
    },
    billId: {
      type: String,
      default: ''
    },
		exportLoading: Boolean,
		downloadLoading:Boolean,
    onlyNoBill: Boolean,
    // 列表没有下载操作
    noDownLoad: Boolean,
    // 没有导出操作
    noExportOption: Boolean,
    isLot: Boolean,
    status: {
      type: String,
      default: null
    },
    isReceiveExamData: {
      type: Boolean,
      default: null
    },
    isOrderBack: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      tableLabels,
      filterLabels: this.isLot ? filterLabels.filter(e=>e.value !== 'status') : filterLabels,
      filterForm: {},
      loading: false,
      settleLoading: false,
      isFuzzy: false,
      isFromRouter: false,
      selectData: [],
      params: {},
      invoiceLoading: false,
      showDelay: false,
      showReassign: false,
      dialogVisible:false
    }
  },
  methods: {
		goDownload(id){
			let data={
				taskIds:[id]
			}
			 this.$emit('getProductionTaskDownloadExcel', data)
		},
    goDetail (id) {
      this.$router.push(`/production-task-detail/${id}`)
    },
    search (val) {
      if (val) {
        this.filterForm.searchKey = val
        this.handleFilter()
      }
    },
    reload () {
      this.$refs.table?.reload()
    },
    emptySearch () {
      this.handleFilter()
    },
    updateSelectedData (data) {
      this.selectData = data
      this.$emit('updateSelectData', data)
    },
    exportHistory () {
      // this.$router.push('/export-history/lab-order?name=lab_export')
      this.$router.push('/export-history/prod-task?name=lab_production_task_export')
		},
		downloadHistory(){
			this.$router.push('/export-history/prod-task?name=lab_task_order_download')
		},
    handleFilter () {
      this.$refs.table?.filter(this.filterForm)
		},
		downloadExcel(){
			if (!this.selectData.length) {
				this.$message.error('请至少选择一条记录下载')
				return
			}
			let data={}
			if (this.selectData) {
				this.params.taskIds = this.selectData.map(e => e.id)
				data = this.params
			}
      this.$confirm('导出操作需要花费一定时间，完成下载后我们会将数据保存在“下载历史”中，您稍后下载即可。', '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.loading = true
        // this.$refs.table.exportExcel(this.params)
        this.$emit('getProductionTaskDownloadExcel', data)
      })
		},
    exportExcel (isAll) {
      let data = {}
      if (isAll === true) {
        data = {}
      } else {
        if (!this.selectData.length) {
          this.$message.error('请至少选择一条记录')
          return
        }
        if (this.selectData) {
          this.params.ids = this.selectData.map(e => e.id)
          data = this.params
        }
      }
      this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.loading = true
        // this.$refs.table.exportExcel(this.params)
        this.$emit('getProductionTaskExportExcel', data)
      })
    },
    cleanParams () {
      emptyObject(this.filterForm)
      this.handleFilter()
    },
    handleReassign () {
      if (!this.selectData.length) {
        this.$message.warning('请勾选您要改派的任务单')
        return
      }
      if ([...new Set(this.selectData.map(e => e.billCode))].length > 1) {
        this.$message.error('当前所选生产任务不属于同一委托单，无法操作')
        return
      }
      this.showReassign = true
    },
    handleDelay () {
      if (!this.selectData.length) {
        this.$message.warning('请勾选您要改派的任务单')
        return
      }
      if ([...new Set(this.selectData.map(e => e.billCode))].length > 1) {
        this.$message.error('当前所选生产任务不属于同一委托单，无法操作')
        return
      }
      this.showDelay = true
    },
    getAllSize(val){
      this.$emit('getAllSize', val)
    }
  },
  created () {
    this.filterForm = this.getObjectFromRoute()
    this.params = this.getObjectFromRoute()
  }
}
</script>
<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.buttons {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.button__box {
  min-width: 100px;
  > big {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
